import { ENDPOINT_BASE } from '@/config/endpoints'

/**
 * SCM connect endpoints are nested under the workspace path:
 *   /api/v1.0/e/{workspaceSlug}/scm/installations
 *   /api/v1.0/e/{workspaceSlug}/scm/bindings
 */
export const ENDPOINT_SCM = `${ENDPOINT_BASE}/e`
